module.exports = __webpack_public_path__ + "img/black-cat.ebf03266.png";